import { categories } from '@/mocks/categories';

export default function CategoryButtons() {
  return (
    <section id="categories" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-3">
          All Vigorbuy Spreadsheet Product Categories
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
          Click any category to explore hand-picked product collections from the Vigorbuy Spreadsheet.
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-300 hover:bg-accent-50/30 transition-all cursor-pointer"
            >
              <div className="w-full h-32 md:h-36 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - Vigorbuy Spreadsheet Category`}
                  title={`${cat.name} - Vigorbuy Spreadsheet Collection`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3 md:p-4 flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-800 leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}